













































































































































import Vue from 'vue';

import store from '@/store';
import { AuthStatus, UserInfo } from '@/store/auth';
import {
  renderSignInButton,
  SignInResponse,
  SignInText
} from '@/api/auth/google';

const signInWithGoogle = (response: SignInResponse) => {
  store.dispatch.auth.loginWithGoogle(response.idToken);
};

export default Vue.extend({
  name: 'Login',

  props: {
    targetUrl: {
      type: String,
      default: '/'
    },
    token: {
      type: String,
      default: ''
    },
    magicToken: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      email: '',
      code: '',
      codeRequested: false
    };
  },

  computed: {
    user(): UserInfo | null {
      return store.state.auth.user;
    },
    isAuthenticated(): boolean {
      return store.state.auth.isAuthenticated;
    },
    status(): AuthStatus {
      return store.state.auth.authStatus;
    },
    failedEmail(): string {
      return store.state.auth.failedEmail;
    },
    showSpinner(): boolean {
      return this.status === AuthStatus.IN_PROGRESS;
    },
    showError(): boolean {
      return this.status === AuthStatus.FAILURE;
    },
    showEnableCookies(): boolean {
      return this.status === AuthStatus.COOKIES_DISABLED;
    }
  },

  methods: {
    signInWithGoogle(response: SignInResponse) {
      store.dispatch.auth.loginWithGoogle(response.idToken);
    },

    signInWithMicrosoft() {
      store.dispatch.auth.loginWithMicrosoft();
    },

    async requestLoginCode() {
      await store.dispatch.auth.requestEmailLoginCode(this.email);
      if (this.status !== AuthStatus.FAILURE) {
        this.codeRequested = true;
      }
    },

    async loginWithEmailCode() {
      await store.dispatch.auth.loginWithEmailCode({
        email: this.email,
        code: this.code
      });

      if (this.status === AuthStatus.FAILURE) {
        this.code = '';
      }
    }
  },

  watch: {
    isAuthenticated(current, previous) {
      const nextUrl = this.targetUrl === '/' ? '/secure/orgs' : this.targetUrl;

      if (current && current !== previous) {
        this.$router.push(nextUrl);
      }
    }
  },

  mounted() {
    if (this.token) {
      store.dispatch.auth.signInWithAccessToken(this.token);
    } else if (this.magicToken) {
      store.dispatch.auth.loginWithMagicLink(this.magicToken);
    }

    if ((!this.token && !this.magicToken) || this.showError) {
      renderSignInButton(
        this.$refs.googleLoginButton as Element,
        SignInText.signInWith,
        signInWithGoogle
      );
    }
  }
});
